import * as getters from "./getters";
import * as mutations from "./mutations";
import * as actions from "./actions";

const state = {
	campuses: [
		{
			value: "UMA",
			text: "Augusta",
			order: 2
		},
		{
			value: "UMF",
			text: "Farmington",
			order: 3
		},
		{
			value: "UMFK",
			text: "Fort Kent",
			order: 4
		},
		{
			value: "UMM",
			text: "Machias",
			order: 5
		},
		{
			value: "UM",
			text: "UMaine",
			order: 1
		},
		{
			value: "USM",
			text: "Southern Maine",
			order: 6
		},
		{
			value: "UMPI",
			text: "Presque Isle",
			order: 6
		}
	]
};

export default {
	state,
	getters,
	mutations,
	actions
};
